export default "__VITE_ASSET__DWHDn1Ub__"